const doAddCard = async (theapp, settings_entry, card_address, card_private_key) => {
	console.log('doAddCard called');

	if (!settings_entry)
	return;

	let new_card;

	try {
		let mvcmywidget = theapp.getMvcMyWidget();
		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		// get current context
		let context = { _refresh_page: false};

		await theapp.getCurrencyContext(context, settings_entry);

		let currency = context.currency;

		if (!currency)
			throw new Error('no current currency');

		if (card_private_key) {
			new_card = await mvcmywidget.createCurrencyCard(rootsessionuuid, walletuuid, currency.uuid, card_private_key);
		}
		else if (card_address) {
			new_card = await mvcmywidget.createReadOnlyCurrencyCard(rootsessionuuid, walletuuid, currency.uuid, card_address);
		}

		if (new_card) {
			// set card as current card
			let settings = await mvcmywidget.readSettings(settings_entry);

			settings.carduuid = new_card.uuid;

			await mvcmywidget.putSettings(settings_entry, settings);
		}
	}
	catch(e) {
		console.log('exception in doAddCard: ' + e);
	}

	return (new_card ? new_card.address : null);
}

export default doAddCard;